import React from 'react';
import './Services.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-calculator',
      title: 'Tax Preparation & Planning',
      description: 'Expert tax preparation for individuals and businesses. Strategic tax planning to minimize your tax liability while ensuring full compliance with regulations.'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Financial Consulting',
      description: 'Comprehensive financial analysis and strategic planning to help you make informed decisions and achieve your financial goals.'
    },
    {
      icon: 'fas fa-building',
      title: 'Business Advisory',
      description: 'Strategic business guidance including financial planning, cash flow management, and growth strategies for small to medium enterprises.'
    },
    {
      icon: 'fas fa-file-invoice-dollar',
      title: 'Bookkeeping Services',
      description: 'Accurate and timely bookkeeping services to keep your financial records organized and compliant with accounting standards.'
    },
    {
      icon: 'fas fa-search-dollar',
      title: 'Financial Audits',
      description: 'Thorough financial audits to ensure accuracy, compliance, and transparency in your financial reporting and operations.'
    },
    {
      icon: 'fas fa-piggy-bank',
      title: 'Investment Planning',
      description: 'Professional investment advice and portfolio management to help you build wealth and secure your financial future.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Services</h2>
          <p className="section-description">Comprehensive financial solutions for your needs</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => {
            const animationRef = useScrollAnimation();
            return (
              <div key={index} className="service-card" ref={animationRef}>
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;